/**
 * The Wishes - birthday messages from real people in Megha's life.
 *
 * Each wish becomes a shooting star that streaks across her sky. When she
 * catches it (clicks while in flight), the wish opens as a card with the
 * sender's name and the message text.
 *
 * The IDs are short slugs from the friend's first name. The texts are
 * placeholders right now - Dhairya will replace them with the real wishes
 * from each person before launch.
 *
 * Recommended count: 8-12 wishes from a representative spread of her people.
 */

export const WISHES = [
  {
    id: 'sheela',
    name: 'Mummy',
    text: "Meghu , I don't know how to express my feelings for you.I am truly blessed to have a daughter like you .Saw you growing 💖 and becoming such a kind loving human being.God  bless you with all happiness and health.Luv you ..Happy Birthday 🎂 🎂 🎂 🎂 🎈 🎈 🎈 🎈 ❤️ ❤️ ❤️ ❤️ ❤️ ",
  },
  {
    id: 'ishwarappa',
    name: 'Papa',
    text: "Happy Birthday Megha\nWishing you the best for this year and many more.",
  },
  {
    id: 'ganesh',
    name: 'Ganesh',
    text: "Happy Birthday, Akka! \nFrom rushing straight to your room after school every day to conquering a 10K marathon, you\'ve come such a long way-I\'m so proud of you.\nThank you for everything you do for me and the family. Wishing you the very best always, and hopefully we\'ll meet up in Europe soon. Here\'s to visiting more countries together!\nHappy Birthday again!",
  },
  {
    id: 'bhagi',
    name: 'Bhagi',
    text: "Happy birthday Megha!!! 🥳🎉\n\nYou're such a fun and energetic person to be around, always up for doing something whether it's a hike, an adventure, trying something creative or just going out to eat. I really like how you bring that excitement and make plans happen (there\'s a reason we call it 'Megha Plans' 😅)\n\nI've really enjoyed getting to know you more over time. From going on walks, hikes, trying new dinner spots, cafes, it's always fun spending time with you. You\'re thoughtful, caring and someone who understands emotions well. You're also someone I can talk to whenever I want to and I hope you know I'm always there for you too.\n\nWishing you lots of happiness, fun and great memories in the year ahead. Hope you had an amazing birthday and celebrate many more to come!!",
  },
  {
    id: 'sneha',
    name: 'Sneha Aunty',
    text: "Beautiful Birthday wishes to the ever cheerful, soft spoken and a loving lady of our family.\nHappy Birthday Megha !",
  },
  {
    id: 'pinku',
    name: 'Pinku',
    text: "Happy Birthday Megha didi🫶🏻\n\nYou’re not just my sister, you’re my built-in friend, my partner in chaos, and the one person who knows all my weirdness and still sticks around 😄 From childhood memories to all the laughs, every moment with you is special to me.\n\nI hope your day is filled with as much joy, love, and fun as you bring into my life. You deserve all the happiness in the world 🎂✨\n\nStay as joyful, kind, and wonderful as you are. Saranghae💜",
  },
  {
    id: 'sai',
    name: 'Sai',
    text: "Happy Birthday Megha Akka 🎉❤️\n\nYou mean so much to me, not just as my sister but as someone I truly admire. The way you keep motivating me-whether it’s in studies or taking care of my health and fitness-really makes a big difference in my life.\n\nAnd honestly, one of my favorite things is when you come home… that’s when everything feels complete. Those are the only times our whole family comes together, and all the trips we go on become such special memories. It just doesn’t feel the same without you.\n\nI’ve learned so much from you, especially about staying strong, disciplined, and positive no matter what. I’m really lucky to have you as my akka.\n\nWishing you lots of happiness, success, good health, and everything you’ve been hoping for. You deserve all the best things in life ❤️\n\nLove you always 🤍✨",
  },
  {
    id: 'shalini',
    name: 'Shalini',
    text: "Happy birthday Megha !\n\nStill funny how this friendship started with you casually assigning me your bed even when I had a perfectly functional room of my own. Personal space really wasn’t part of the onboarding process.\n\nThen came the legendary 11:30 PM “walks” which were actually just strategic chocolate procurement missions. Buying expensive chocolates in bulk while being broke college students was bold behavior. Finishing half of it before even returning to PG was just… operational efficiency.\n\nAnd of course, the highly confidential sessions of ranting about our “then” partners-like we were conducting some serious research, but with zero academic value.\n\nWe were in different groups, different routines, but somehow still functioned as a package deal where it mattered. No drama, no planning, just chaos with consistency.\n\nNow you’re in the US, but I’m fairly certain even if you go to space 🚀 for “more space,” you’ll still manage to stay connected. Unfortunately for everyone involved.\n\nThankyou for being born and becoming my baggage🫣",
  },
  {
    id: 'bansari',
    name: 'Bansari Didi',
    text: "Happy Birthday Megha! Wishing you a wonderful and adventure filled year. May you always a fun trip to look forward to and may your travel credit card always keep giving you awesome deals 😎.",
  },
  {
    id: 'nova',
    name: 'Nova',
    text: "Woof woof woof woof, lou you Megha, woof woof woof woof, when’s the paw-ty?",
  },
  {
    id: 'anshul',
    name: 'Anshul Bhaiya',
    text: "Happy Birthday, Megha!! 🎂🎁🎊💐😄\n\nHere’s to celebrating you today 🎉 It’s been so special getting to know you over the past almost three years. From starting out as shy, quiet acquaintances to becoming drinking buddies and genuinely close friends, it’s been such a fun and meaningful journey.  \n\nI truly feel happy and grateful to have you as my sister and part of my Seattle family. Wishing you a wonderful birthday and an amazing year ahead filled with happiness, growth, and everything you love.  \n\nLooking forward to all the great memories we’ll create this year and many more to come 😄",
  },
  {
    id: 'ajji',
    name: 'Ajji',
    text: "Happy Birthday, Megha!\nMay God bless you always. Wishing you good health and a life full of happiness and prosperity.\nMy child, may your smile always remain as bright and joyful as it is today. Your smile will forever stay in my heart. No matter how big you grow, you will always be my little Megha.\nKeep laughing, smiling, and spreading joy wherever you go. You have brought so much happiness into my life.\nI will always cherish the wonderful memories we made in Dubai. I truly enjoyed every moment there with you all, and I’m so grateful for the love and care you gave me. I will never forget it.\nI am so proud to be your Ajji and to have you as my granddaughter. May you always stay happy in life, I pray to God for your happiness always.\n\nYour loving, ajji🥰",
  },
  {
    id: 'mala',
    name: 'Mala Aunty',
    text: "Happy Birthday, Meghu! 🎉\n\nYou’ve always been so special to all of us-being the first daughter of our family, you were loved and cherished by everyone from the very beginning. And even today, if you’re around, everyone is happy-your presence brings so much joy and warmth.\n\nYou’ve grown into such an independent person, handling everything with confidence and strength, which makes us all so proud. I still remember those childhood days-every time we visited Kerala and had to come back, you would cry. It showed how deeply you feel and how much you value love and togetherness.\n\nYou’ve become such a supportive and caring person, always standing by others no matter what. We’re truly lucky to have you.\n\nWishing you a day full of happiness, laughter, and everything you love. Keep shining, Meghu! 💛",
  }
];

/** Build the HTML for a wish card. */
export function wishCardHTML(wish) {
  const paragraphs = escapeHtml(wish.text)
    .split(/\n\n+/)
    .map((para) => `<p>${para.replace(/\n/g, '<br>')}</p>`)
    .join('');
  return `
    <h2>${escapeHtml(wish.name)}</h2>
    ${paragraphs}
  `;
}

function escapeHtml(s) {
  if (!s) return '';
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
